import { getLoginHistory } from "@services/statistic/login-history";
import { getLoginSummary } from "@services/statistic/login-summary";
import { getLoginGroupChange } from "@services/statistic/login-group-change";
import { getLoginTrades } from "@services/statistic/login-trades";
import i18n from "@/i18n";

const state = {
    loginHistoryChartTimeDate: [],
    loginHistoryChartSeriesData: [],
    loginHistoryChartLegendData: [],
    loginGroupChangeData: [],
    loginCloseTradesData: [],
    loginOpenTradesData: [],
    loginGroupChangeHeader: [
        {
            text: i18n.t("common.table.server"),
            value: "server_id",
            width: 80,
            align: "left",
        },
        {
            text: i18n.t("common.table.fromGroup"),
            value: "from_group",
            width: 80,
            align: "left",
        },
        {
            text: i18n.t("common.table.toGroup"),
            value: "to_group",
            width: 80,
            align: "left",
        },
        {
            text: i18n.t("common.table.equity"),
            value: "equity",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.triggerTime"),
            value: "created_at",
            width: 80,
            align: "left",
        },
    ],
    loginSummary: {},
    loading: false,
    openTradeLoading: false,
    closeTradesHeader: [
        {
            text: i18n.t("common.table.positionID"),
            value: "positionID",
            width: 100,
            align: "left",
        },
        {
            text: i18n.t("common.table.order"),
            value: "order",
            width: 80,
            align: "left",
            sortable: true,
        },
        {
            text: i18n.t("common.table.type"),
            value: "cmd",
            width: 60,
            align: "left",
            sortable: true,
        },
        {
            text: i18n.t("common.table.lot"),
            value: "volume",
            width: 80,
            align: "right",
            sortable: true,
        },
        {
            text: i18n.t("common.table.openTime"),
            value: "openTime",
            width: 170,
            align: "left",
        },
        {
            text: i18n.t("common.table.closeTime"),
            value: "closeTime",
            width: 170,
            align: "left",
        },
        {
            text: i18n.t("common.table.openPrice"),
            value: "openPrice",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.closePrice"),
            value: "closePrice",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.eodAsk"),
            value: "eodAsk",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.eodBid"),
            value: "eodBid",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.profit"),
            value: "profit",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.profitMT"),
            value: "realizedMT",
            width: 120,
            align: "right",
        },
        {
            text: i18n.t("common.table.profitEOD"),
            value: "realizedEOD",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.tp"),
            value: "tp",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.sl"),
            value: "sl",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.reason"),
            value: "reason",
            width: 80,
            align: "left",
        },
        {
            text: i18n.t("common.table.commission"),
            value: "commission",
            width: 90,
            align: "right",
        },
        {
            text: i18n.t("common.table.swaps"),
            value: "storage",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.exchangeCalculation"),
            value: "extraInfo",
            width: 90,
            align: "left",
        },
    ],
    openTradesHeader: [
        {
            text: i18n.t("common.table.positionID"),
            value: "positionID",
            width: 100,
            align: "left",
        },
        {
            text: i18n.t("common.table.order"),
            value: "order",
            width: 80,
            align: "left",
            sortable: true,
        },
        {
            text: i18n.t("common.table.type"),
            value: "cmd",
            width: 60,
            align: "left",
            sortable: true,
        },
        {
            text: i18n.t("common.table.lot"),
            value: "volume",
            width: 80,
            align: "right",
            sortable: true,
        },
        {
            text: i18n.t("common.table.openTime"),
            value: "openTime",
            width: 170,
            align: "left",
        },
        {
            text: i18n.t("common.table.openPrice"),
            value: "openPrice",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.currentAsk"),
            value: "currentAsk",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.currentBid"),
            value: "currentBid",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.eodAsk"),
            value: "eodAsk",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.eodBid"),
            value: "eodBid",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.profit"),
            value: "profit",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.profitMT"),
            value: "unrealizedMT",
            width: 120,
            align: "right",
        },
        {
            text: i18n.t("common.table.profitEOD"),
            value: "unrealizedEOD",
            width: 100,
            align: "right",
        },
        {
            text: i18n.t("common.table.realizedEOD"),
            value: "realizedEOD",
            width: 120,
            align: "right",
        },
        {
            text: i18n.t("common.table.tp"),
            value: "tp",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.sl"),
            value: "sl",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.reason"),
            value: "reason",
            width: 80,
            align: "left",
        },
        {
            text: i18n.t("common.table.commission"),
            value: "commission",
            width: 90,
            align: "right",
        },
        {
            text: i18n.t("common.table.swaps"),
            value: "storage",
            width: 80,
            align: "right",
        },
        {
            text: i18n.t("common.table.exchangeCalculation"),
            value: "extraInfo",
            width: 90,
            align: "left",
        },
    ],
    reasonList: {
        0: i18n.t("common.reason.client"),
        1: i18n.t("common.reason.expert"),
        2: i18n.t("common.reason.dealer"),
        3: i18n.t("common.reason.signal"),
        4: i18n.t("common.reason.gateway"),
        5: i18n.t("common.reason.mobile"),
        6: i18n.t("common.reason.web"),
        7: i18n.t("common.reason.api"),
    },
    profitMode: {
        MT4: {
            0: i18n.t("common.profitMode.forex"),
            1: i18n.t("common.profitMode.cfd"),
            2: i18n.t("common.profitMode.futures"),
        },
        MT5: {
            0: i18n.t("common.profitMode.forex"),
            1: i18n.t("common.profitMode.futures"),
            2: i18n.t("common.profitMode.cfd"),
            3: i18n.t("common.profitMode.cfdIndex"),
            4: i18n.t("common.profitMode.cfdLeverage"),
            5: i18n.t("common.profitMode.forexNoLeverage"),
        },
    },
};

const actions = {
    /**
     * Get login history detail
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  params  [params contain login and broker id]
     * @return  {[type]}          [return description]
     */
    getLoginHistoryAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        getLoginHistory(params).then((res) => {
            let chartTimeDate = res.data.xdata || [];
            let loginHistoryChartTimeDate = chartTimeDate.map(function (str) {
                return str.substring(2, str.length - 9);
            });

            commit(
                "UPDATE_LOGIN_HISTORY_CHART_TIME_DATE",
                loginHistoryChartTimeDate
            );

            const dailyPnl = {
                name: i18n.t("common.table.dailyPnl"),
                type: "line",
                symbolSize: 8,
                emphasis: { scale: false },
                symbol: "circle",
                yAxisIndex: 2,
                data: res.data?.ydata?.daily_pnl || [],
            };

            const balance = {
                name: i18n.t("common.table.balance"),
                type: "line",
                emphasis: { scale: false },
                symbol: "circle",
                data: res.data?.ydata?.balance || [],
            };

            const equity = {
                name: i18n.t("common.table.equity"),
                type: "line",
                emphasis: { scale: false },
                symbol: "circle",
                data: res.data?.ydata?.equity || [],
            };

            const dpm = {
                name: "DPM",
                type: "bar",
                emphasis: { scale: false },
                symbol: "circle",
                yAxisIndex: 1,
                data: res.data?.ydata?.dpm || [],
            };

            let legendData = [];
            let seriesData = [];
            legendData.push(dailyPnl.name);
            seriesData.push(dailyPnl);
            legendData.push(balance.name);
            seriesData.push(balance);
            legendData.push(equity.name);
            seriesData.push(equity);
            legendData.push(dpm.name);
            seriesData.push(dpm);

            commit("UPDATE_LOGIN_HISTORY_CHART_SERIES_DATA", seriesData);
            commit("UPDATE_LOGIN_HISTORY_CHART_LEGEND_DATA", legendData);
            commit("UPDATE_LOADING", false);
        });
    },
    /**
     * Get login summary detail
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  params  [params description]
     * @return  {[type]}          [return description]
     */
    getLoginSummaryAction({ commit }, params) {
        getLoginSummary(params).then((res) => {
            if (res.data.length !== 0) {
                commit("UPDATE_LOGIN_SUMMARY", res.data[0]);
            } else {
                commit("UPDATE_LOGIN_SUMMARY", {});
            }
        });
    },
    getLoginGroupChangeAction({ commit }, params) {
        getLoginGroupChange(params).then((res) => {
            if (res.data.length !== 0) {
                commit("UPDATE_LOGIN_GROUP_CHANGE_INFO", res.data);
            } else {
                commit("UPDATE_LOGIN_GROUP_CHANGE_INFO", []);
            }
        });
    },
    getLoginCloseTradesAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        getLoginTrades(params)
            .then((res) => {
                if (res.length !== 0) {
                    state.loginCloseTradesData = res.data;
                } else {
                    state.loginCloseTradesData = [];
                }
                commit("UPDATE_LOADING", false);
            })
            .catch((error) => {
                console.log(error);
                commit("UPDATE_LOADING", false);
            });
    },
    getLoginOpenTradesAction({ commit }, params) {
        state.openTradeLoading = true;
        getLoginTrades(params)
            .then((res) => {
                if (res.length !== 0) {
                    state.loginOpenTradesData = res.data;
                } else {
                    state.loginOpenTradesData = [];
                }
                state.openTradeLoading = false;
            })
            .catch((error) => {
                console.log(error);
                commit("UPDATE_LOADING", false);
            });
    },
};

const mutations = {
    UPDATE_LOGIN_SUMMARY(state, data) {
        state.loginSummary = data;
    },
    UPDATE_LOGIN_GROUP_CHANGE_INFO(state, data) {
        state.loginGroupChangeData = data;
    },
    /**
     * Update login history chart time
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOGIN_HISTORY_CHART_TIME_DATE(state, data) {
        state.loginHistoryChartTimeDate = data;
    },
    /**
     * Update login history chart series data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOGIN_HISTORY_CHART_SERIES_DATA(state, data) {
        state.loginHistoryChartSeriesData = data;
    },
    /**
     * Update login history chart time legend data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOGIN_HISTORY_CHART_LEGEND_DATA(state, data) {
        state.loginHistoryChartLegendData = data;
    },
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_CLOSE_TRADE_DATA(state, data) {
        state.loginCloseTradesData = data;
    },
    UPDATE_OPEN_TRADE_DATA(state, data) {
        state.loginOpenTradesData = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
